import { render, staticRenderFns } from "./ThumbnailFileImage.vue?vue&type=template&id=2b589a06&scoped=true&"
import script from "./ThumbnailFileImage.vue?vue&type=script&lang=js&"
export * from "./ThumbnailFileImage.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailFileImage.vue?vue&type=style&index=0&id=2b589a06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b589a06",
  null
  
)

export default component.exports